
import { Component, Prop, Vue } from 'vue-property-decorator';
import { GiftshopProduct, GiftshopVariant } from '@/models/Giftshop';
import { ProductResourceImage } from '@/models/Product';
import VariantSelectorImageButton from '@/components/product-details/VariantSelectorImageButton.vue';
import VariantSelectorTextButton from '@/components/product-details/VariantSelectorTextButton.vue';

@Component({
    name: 'GiftshopSelectionModalProductVariants',
    components: {
        VariantSelectorImageButton,
        VariantSelectorTextButton,
    }
})
export default class GiftshopSelectionModalProductVariants extends Vue {
    @Prop({ type: Object, required: true }) product: GiftshopProduct;
    @Prop({ type: Object, required: false }) selectedVariant: GiftshopVariant;
    @Prop({ type: String, required: false }) selectedDimension1: string;

    get variants(): GiftshopVariant[] {
        return this.product.variants;
    }
    get selectedVariantId(): string {
        return this.selectedVariant.id;
    }    
    get selectedDimension1Label(): string {
        return this.dimension1Options.get(this.selectedDimension1);
    }
    get selectedVariantLabel() {
        if (!this.selectedVariant) return '';
        return this.dimensionCount === 1 ? this.selectedVariant.dimension1label : this.selectedVariant.dimension2label;
    }
    get group1label(): string {
        return this.variants?.[0]?.group1label;
    }
    get variantOptionslabel(): string {
        if (this.dimensionCount === 1) {
            return this.variants?.[0]?.group1label;
        }
        if (this.dimensionCount === 2) {
            return this.variants?.[0]?.group2label;
        }
        return '';
    }
    get dimensionCount(): number {
        return this.variants?.[0]?.dimensioncount;
    }
    get dimension1Options(): Map<string, string> {
        const map = new Map<string, string>();
        this.variants?.forEach((variant: GiftshopVariant) => {
            map.set(variant.dimension1code, variant.dimension1label);
        });
        return map;
    }
    get variantOptions(): GiftshopVariant[] {
        if (this.dimensionCount === 1) {
            return this.variants;
        }
        if (this.dimensionCount === 2) {
            return this.variants?.filter((variant: GiftshopVariant) => variant.dimension1code === this.selectedDimension1);
        }
        return [];
    }

    private getSizeUrl(img: ProductResourceImage, size: string = 'small') {
        return img?.variants[size] ?? img?.url;
    }
    private getLabel(variant: GiftshopVariant) {
        return this.dimensionCount === 1 ? variant.dimension1label : variant.dimension2label;
    }
    private getDimension1Image(dimensionCode: string): string {
        return this.product?.dimension1images[dimensionCode?.toLowerCase()]?.[0]?.url ?? '';
    }

    private selectVariant(variant: GiftshopVariant) {
        this.$emit('select-variant', variant);
    }
    private selectDimension1(dimensionCode: string) {
        this.$emit('select-variant-dimension1', dimensionCode);
    }
}
